import React, { useState } from 'react';
import { Input, Button } from 'semantic-ui-react';
import { apimCall } from '../../../utility/api';
import { Module } from '../../Module';
import { useProfile } from '../../../context/ProfileContext';
import { canIUse, AppFeatures } from '../../../utility/SecurityHelper';
import { CommentInput } from '../../commentinput/CommentInput';

export type AdjustCreditsProps = {
  id: string;
  account: TypeMePlease;
  history?: TypeMePlease;
};

export default function AdjustCredits(props: AdjustCreditsProps) {
  const { id, history } = props;
  const [saving, setSaving] = useState(false);
  const [comment, setComments] = useState('');
  const [credits, setCredits] = useState('');
  const [price, setPrice] = useState('');
  const { profile } = useProfile();
  const internalUsername = profile.username;

  const save = async () => {
    setSaving(true);
    const request = { internalUsername, credits, price, comment };
    await apimCall('/billing/credits/adjust', 'POST', request, id, null);
    setComments('');
    setSaving(false);
    history.push(`/account/${id}/publicforms`);
  };

  return (
    <div className="adjustCredits">
      <div className="modules">
        <Module title="Add/Remove Credits" className="fullwidth-module">
          <table className="ui very basic collapsing celled table">
            <thead>
              <tr>
                <th>Number of Credits</th>
                <th>Total Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="field">
                  <Input
                    type="number"
                    value={credits}
                    onChange={(e) => setCredits(e.target.value)}
                    disabled={!canIUse(AppFeatures.EditFinancialAccountSettings)}
                  ></Input>
                </td>
                <td className="field">
                  <Input
                    type="number"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    disabled={!canIUse(AppFeatures.EditFinancialAccountSettings)}
                  ></Input>
                </td>
              </tr>
            </tbody>
          </table>
          <div className="ui form">
            <br />
            <CommentInput placeholder="Comment."
                  value={comment} onChange={setComments} 
                  disabled={!canIUse(AppFeatures.EditFinancialAccountSettings)}/>
            <br />
            <Button className="primary" onClick={save} loading={saving} disabled={!comment}>
              Save
            </Button>
          </div>
        </Module>
      </div>
    </div>
  );
}
